import { RouteObject } from 'react-router-dom';

export const trainerRoutes: RouteObject[] = [
  {
    lazy: async () => ({
      Component: (await import('@app/router/hocs'))
        .TrainerProtectedRoute,
    }),
    path: 'trainer',
    children: [
      {
        path: 'dashboard',
        lazy: async () => ({
          Component: (await import('@pages/dashboard')).DashboardPage,
        }),
      },
      {
        path: 'trainer-create-user',
        lazy: async () => ({
          Component: (await import('@pages/admin-create-user')).AdminCreateUser,
        }),
      },
      // {
      //   path: '/users-management',
      //   lazy: async () => ({
      //     Component: (await import('@pages/users-management'))
      //       .UsersManagementPage,
      //   }),
      // },
      {
        path: 'event-calendar',
        lazy: async () => ({
          Component: (await import('@pages/event-calendar'))
            .TrainerEventCalendarPage,
        }),
      },
      {
        path: 'event-management',
        lazy: async () => ({
          Component: (await import('@pages/event-management'))
            .TrainerEventManagementPage,
        }),
      },
    ],
  },
];